import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import swal from 'sweetalert'
import { firestorePlugin } from 'vuefire'

Vue.use(firestorePlugin);

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js